import { z } from 'zod'

export default z
  .union([
    z.string({ required_error: 'value is required' }),
    z.boolean({ required_error: 'value is required' }),
  ])
  .refine(
    val => {
      if (typeof val === 'string') return val.length >= 1
      if (typeof val === 'boolean') return val === true
      return false
    },
    { message: 'value is required' }
  )
